module.exports = __webpack_public_path__ + "media/pos-error.4e657bee.mp3";